import { StyleSheet, Font } from "@react-pdf/renderer";

import Regular from "../../../assets/fonts/roboto/Roboto-Regular.ttf";
import Italic from "../../../assets/fonts/roboto/Roboto-Italic.ttf";
import Bold from "../../../assets/fonts/roboto/Roboto-Bold.ttf";
import Black from "../../../assets/fonts/roboto/Roboto-Black.ttf";

Font.register({
  family: "Roboto",
  fonts: [
    { src: Regular },
    { src: Italic, fontStyle: "italic" },
    { src: Bold, fontWeight: "bold" },
    { src: Black, fontWeight: "heavy" },
  ],
});

export const styles = StyleSheet.create({
  page: {
    width: "100%",
    backgroundColor: "white",
  },
  spaceBetweenRow: {
    display: "flex",
    width: "100%",
    padding: "10px 10px 0 0",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  orderDetailHeader: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: "wrap",

    paddingTop: 4,
    paddingBottom: 4,
    paddingRight: 10,
    paddingLeft: 10,
  },
  rowEvenSpace: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-evenly",
  },
  categoryCol: {
    width: "11.11%",
    justifyContent: "flex-start",

    fontSize: 8,
    fontFamily: "Roboto",
    marginTop: 5,
    marginBottom: 5,
    flexDirection: "row",
  },
  Detailrow: {
    overflow: "hidden",
    width: "100%",
    flexDirection: "row",
    maxWidth: "100%",
  },
  row: {
    overflow: "hidden",
    width: "100%",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  headAddress: {
    display: "flex",
    flexDirection: "row",
  },
  rowSection: {
    width: "100%",
    flexDirection: "row",
  },
  column: {
    display: "flex",
    flexDirection: "column",
  },
  packingSlip: {
    paddingLeft: 10,
    fontSize: 14,
    fontWeight: 700,
    marginTop: 5,
    color: "#D9134D",
    fontFamily: "Roboto",
  },
  pdfEatOutNameView: {
    display: "flex",
    alignSelf: "center",
  },
  pdfEatOutName: {
    paddingTop: 25,
    paddingLeft: 30,
    marginRight: 30,
    fontSize: 16,
    marginTop: 10,
  },
  sellerAddress2: {
    marginLeft: "auto",
    marginRight: 30,
    fontSize: 8,
    marginTop: 10,
    paddingTop: 25,
  },
  paddingPackingSlip: {
    paddingLeft: 10,
    paddingRight: 10,
    display: "flex",
    marginTop: 5,
  },

  parentDiv: {
    display: "flex",
    paddingTop: 35,
    paddingLeft: 35,
    marginBottom: 10,
  },
  pdfEatOutPosNameView: {
    display: "flex",
    marginBottom: 10,
  },
  pdfPosEatOutName: {
    fontSize: 12,
    marginTop: 4,
  },
  detailSectionParent: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingRight: 35,
    marginTop: 5,
  },
  dayEndFood: {
    marginTop: 20,
  },
  detailSectionText: {
    fontSize: 10,
    color: "#212121",
    fontFamily: "Roboto",
  },
  detailSectionFood: {
    fontSize: 10,
    color: "#212121",
    fontFamily: "Roboto",
  },
  tableHeadPosPdf: {
    flexDirection: "row",
    marginTop: 10,
    backgroundColor: "#F5F5F5",
    borderBottom: 1,
    borderLeft: 1,
    borderRight: 1,
    borderColor: "#f2f0f1",
    borderRadius: 0,
    marginRight: 25,
  },
  tablePaddingPdfPos: {
    display: "flex",
    flexDirection: "row",
    padding: 4,
    marginLeft: 6,
  },
  eatOutUserName: {
    fontSize: 10,
    lineHeight: 1,
    marginLeft: 35,
  },
  eatOutUserNameTable: {
    fontSize: 10,
    marginLeft: 10,
  },
  totalTable: {
    fontSize: 10,
  },
  tablePaddingRow: {
    display: "flex",
    flexDirection: "row",
    padding: 4,
  },
  numRowPdfPos: {
    marginTop: 4,
    marginBottom: 4,
    fontSize: 8,
    marginLeft: 10,
  },
  noOfCheckPdf: {
    fontSize: 10,
    marginLeft: 5,
    marginTop: 4,
    marginBottom: 4,
  },
  textInternalTable: {
    marginTop: 4,
    marginBottom: 4,
    fontSize: 10,
    marginLeft: 20,
  },
  textInternalGrandTable: {
    marginTop: 4,
    marginBottom: 4,
    fontSize: 10,
  },
  textInternalProfileTable: {
    marginTop: 4,
    marginBottom: 4,
    fontSize: 10,
    marginLeft: 18,
  },
  totalCreditCss: {
    marginTop: 4,
    marginBottom: 4,
    fontSize: 10,
  },
  image: {
    width: "60px",
    height: "60px",
    marginLeft: "auto",
    marginRight: 30,
    objectFit: "contain",
  },
  texth1: {
    marginLeft: "auto",
    marginRight: 30,
    fontSize: 12,
    marginTop: 10,
    paddingTop: 25,
  },
  sellerAddress: {
    marginLeft: "auto",
    marginRight: 30,
    fontSize: 8,
    marginTop: 5,
  },
  divider: {
    marginLeft: 30,
    marginRight: 30,
    marginBottom: 3,
    width: "90%",
    height: 1,
    backgroundColor: "#c4c2c2",
    marginTop: 2,
  },
  dividerGrandTotal: {
    marginRight: 8,
    marginBottom: 3,
    width: "100%",
    height: 1,
    backgroundColor: "#c4c2c2",
    marginTop: 2,
  },
  headerDivider: {
    marginLeft: 5,
    marginRight: 5,
    marginBottom: 1,
    marginTop: 4,
    width: "97%",
    backgroundColor: "#EDEDED",
    height: 1,
  },
  skuB: {
    marginLeft: 30,
    padding: "4px",
    fontSize: 10,
    marginTop: 1,
    color: "#757575",
    fontFamily: "Roboto",
  },
  statusCss: {
    padding: "4px",
    fontSize: 10,
    marginTop: 1,
    color: "#000000",

    fontFamily: "Roboto",
  },
  statusCommentCss: {
    fontSize: 10,
    marginTop: 1,
    marginLeft: 10,
    color: "#000000",
    fontFamily: "Roboto",
  },
  tablecolPdf: {
    lineHeight: 1.1,
    width: "11.11%",
    display: "flex",
    justifyContent: "flex-end",
    marginLeft: "auto",
    marginRight: "auto",
    fontSize: 8,
    marginTop: 5,
    marginBottom: 5,
  },
  tablecolPdfTotal: {
    lineHeight: 1.1,
    width: "11.11%",
    display: "flex",
    justifyContent: "flex-end",
    marginLeft: "10px",
    marginRight: "auto",
    fontSize: 8,
    marginTop: 5,
    marginBottom: 5,
  },
  tableColPdfTotal: {
    lineHeight: 1.1,
    width: "11%",
    display: "flex",
    justifyContent: "flex-end",
    marginLeft: "auto",
    marginRight: "auto",
    fontSize: 8,
    marginTop: 5,
    marginBottom: 5,
  },
  sku: {
    fontFamily: "Roboto",
    justifyContent: "flex-start",
    marginLeft: "34px",
    fontSize: 10,
    color: "#757575",
  },
  pcode: {
    lineHeight: 1.1,
    width: "40%",
    marginLeft: 10,
    justifyContent: "flex-end",
    marginRight: 10,
    fontSize: 8,
    marginTop: 1,
    marginBottom: 1,
    color: "#121111",
  },
  tablerowhead: {
    flexDirection: "row",
    marginLeft: 30,
    marginRight: 30,
    paddingLeft: 2,
    paddingRight: 2,
    backgroundColor: "#F5F5F5",
    borderBottom: 1,
    borderLeft: 1,
    borderRight: 1,
    borderColor: "#f2f0f1",
    borderRadius: 0,
  },
  tablerowheadPdf: {
    flexDirection: "row",
    marginBottom: 10,
  },
  tableBoxCredit: {
    borderTop: 1,
    borderBottom: 1,
    borderLeft: 1,
    borderRight: 1,
    borderColor: "#f2f0f1",
    borderRadius: 0,
  },
  marginsTopBottom: {
    marginTop: 4,
    marginBottom: 4,
    marginRight: 10,
    marginLeft: 10,
  },
  sellerHeading: {
    marginLeft: 0,
    fontSize: 14,
    fontWeight: 600,
  },
  logoContainer: {
    display: "flex",
    alignSelf: "flex-start",
    marginLeft: "10px",
  },
  sellerDetails: {
    display: "flex",
    marginTop: "auto",
  },
  sellerDetailBox: {
    display: "flex",
    marginLeft: 10,
    overflow: "hidden",
    width: 200,
    marginTop: "auto",
  },
  spaceBox: {
    marginTop: 15,
    overflow: "hidden",
    width: 150,
  },
  logoCss: {
    width: "80px important",
    objectFit: "contain !important",
  },
  billingBox: {
    width: "100%",
    paddingRight: 5,
    marginRight: 10,
    marginTop: "auto",
    paddingLeft: 5,
    height: "auto",
  },
  headBox: {
    marginLeft: 30,
    padding: 10,
    marginTop: 8,
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 16,
    overflow: "hidden",
    width: 250,
    backgroundColor: "#F5F5F5",
    borderTop: 1,
    borderBottom: 1,
    borderLeft: 1,
    borderRight: 1,
    borderColor: "#f2f0f1",
    borderStyle: "solid",
    borderRadius: 0,
  },
  fullWidthStats: {
    marginLeft: 30,
    width: 600,
    height: 150,
    paddingTop: 20,
    paddingBottom: 30,
    paddingLeft: 16,
    display: "flex",
    flexDirection: "column",
  },
  cardSectionCSS: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
  },
  businessInfoStyles: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    maxWidth: "50%",
  },
  userInfoStyles: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    maxWidth: "50%",
    justifyContent: "flex-end",
    alignItems: "flex-end",
  },
  detailBoxCustomerDetail: {
    marginLeft: 30,
    width: 250,
    height: 130,
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: "16px",
    borderTop: 1,
    borderBottom: 1,
    borderLeft: 1,
    borderRight: 1,
    borderColor: "#f2f0f1",
    borderStyle: "solid",
    borderRadius: 0,
    display: "flex",
    flexDirection: "column",
    marginBottom: 10,
  },
  boxTextCss: {
    fontFamily: "Roboto",
    width: "40%",
    fontSize: 10,
    justifyContent: "flex-start",
    color: "#212121",
  },
  detailBoxTextCss: {
    fontFamily: "Roboto",
    marginTop: 2,
    justifyContent: "flex-start",
    fontSize: 9,
    color: "#757575",
    display: "flex",
    width: "30%",
  },
  customerDetailsHeading: {
    fontFamily: "Roboto",
    marginTop: 2,
    justifyContent: "flex-start",
    fontSize: 10,
    fontWeight: 500,
    display: "flex",
    width: "22%",
  },
  commentAndNote: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: 4,
    width: "80%",
  },
  noteHeading: {
    fontFamily: "Roboto",
    fontSize: 9,
    color: "#5D6481",
  },
  customerDetailsNote: {
    fontFamily: "Roboto",
    fontSize: 9,
    fontWeight: 700,
    color: "#5D6481",
  },
  customerDetailsText: {
    fontFamily: "Roboto",
    marginTop: 5,
    justifyContent: "flex-start",
    fontSize: 9,
    color: "#5D6481",
    display: "flex",
    width: "70%",
    fontWeight: 400,
  },
  sellerEmailNumberAddress: {
    marginTop: 4,
    fontSize: 10,
    fontWeight: 400,
    color: "#5D6481",
  },
  middleSectionHeadings: {
    fontFamily: "Roboto",
    marginTop: 2,
    fontSize: 10,
    fontWeight: 400,
    maxWidth: "22%",
  },
  middleSectionValues: {
    fontFamily: "Roboto",
    marginTop: 2,
    maxWidth: "22%",
    fontSize: 10,
    fontWeight: 700,
    color: "#5D6481",
  },
  customerDetailBoxTextCss: {
    fontFamily: "Roboto",
    marginTop: 2,
    justifyContent: "flex-start",
    fontSize: 9,
    color: "#757575",
    display: "flex",
    width: "22%",
  },
  detailBoldTextCss: {
    lineHeight: "15px",
    fontFamily: "Roboto",
    justifyContent: "flex-start",
    fontSize: 9,
    marginTop: 2,
    color: "#212121",
    marginLeft: "0px",
  },
  detailBoldTextDate: {
    lineHeight: "15px",
    fontFamily: "Roboto",
    justifyContent: "flex-start",
    fontSize: 9,
    marginTop: 2,
    color: "#212121",
  },
  detailBoldTextCssOrderId: {
    lineHeight: "15px",
    fontFamily: "Roboto",
    justifyContent: "flex-start",
    fontSize: 9,
    marginTop: 2,
    color: "#212121",
  },
  detailBoxTextCssPaymentType: {
    lineHeight: "15px",
    fontFamily: "Roboto",
    justifyContent: "flex-start",
    fontSize: 9,
    marginTop: 2,
    color: "#212121",
  },
  detailBoxTextCssPaymentTypeOderId: {
    lineHeight: "15px",
    fontFamily: "Roboto",
    justifyContent: "flex-start",
    fontSize: 9,
    marginTop: 2,
    color: "#212121",
  },
  detailBoxTextCssPaymentTypeName: {
    lineHeight: "15px",
    fontFamily: "Roboto",
    justifyContent: "flex-start",
    fontSize: 9,
    marginTop: 2,
    color: "#212121",
    width: "70%",
  },
  detailBoxTextCssPaymentTypeMobile: {
    lineHeight: "15px",
    fontFamily: "Roboto",
    justifyContent: "flex-start",
    fontSize: 9,
    marginTop: 2,
    color: "#212121",
    width: "70%",
  },
  detailBoxTextCssPaymentTypeAddress: {
    fontFamily: "Roboto",
    fontSize: 9,
    marginTop: 2,
    color: "#212121",
    flexWrap: "wrap",
    width: "70%",
    display: "flex",
  },
  detailBoxTextCssPaymentTypeEmail: {
    fontFamily: "Roboto",
    fontSize: 9,
    marginTop: 2,
    color: "#212121",
    flexWrap: "wrap",
    width: "70%",
    display: "flex",
  },
  detailBoxTextCssNote: {
    lineHeight: "15px",
    fontFamily: "Roboto",
    fontSize: 10,
    fontWeight: 400,
    marginTop: 2,
    color: "#212121",
    flexWrap: "wrap",
    width: "70%",
  },
  detailBoldTextCssNote: {
    lineHeight: "15px",
    fontFamily: "Roboto",
    justifyContent: "flex-start",
    fontSize: 9,
    marginTop: 2,
    color: "#212121",
    marginLeft: 46,
  },
  detailBoxTextCssPaymentTypeDeliveryTime: {
    lineHeight: "15px",
    fontFamily: "Roboto",
    justifyContent: "flex-start",
    fontSize: 9,
    marginTop: 2,
    color: "#212121",
    marginLeft: 10,
  },
  numbertablecol: {
    width: "10%",
    justifyContent: "flex-start",
  },
  numbertablecolQuantity: {
    width: "10%",
    justifyContent: "flex-start",
    marginLeft: 5,
  },
  tablecol: {
    width: "19%",
    justifyContent: "flex-start",
    marginLeft: 2,
  },
  tablecolItem: {
    width: "17%",
    justifyContent: "flex-start",
    marginLeft: 2,
  },
  tableColPdf: {
    lineHeight: 1.1,
    width: "11%",
    justifyContent: "flex-start",
    marginLeft: "auto",
    marginRight: "auto",
    fontSize: 8,
    fontFamily: "Roboto",
    flexDirection: "row",
    marginTop: 5,
    marginBottom: 5,
  },
  tableColPdfWeight: {
    lineHeight: 1.1,
    width: "11.11%",
    display: "flex",
    justifyContent: "flex-end",
    marginLeft: "auto",
    marginRight: "auto",
    fontSize: 8,
    fontFamily: "Roboto",
    marginTop: 5,
    flexDirection: "row",
    marginBottom: 5,
  },
  tableColPdfBrand: {
    lineHeight: 1.1,
    width: "11.11%",
    display: "flex",
    justifyContent: "flex-start",
    marginLeft: "auto",
    fontSize: 8,
    fontFamily: "Roboto",
    marginTop: 5,
    flexDirection: "row",
    marginBottom: 5,
    marginRight: "auto",
  },
  tableColPdfPrice: {
    lineHeight: 1.1,
    width: "11.11%",
    fontSize: 8,
    fontFamily: "Roboto",
    marginTop: 5,
    marginBottom: 5,
    flexDirection: "row",
    display: "flex",
    justifyContent: "flex-end",
  },
  tablecolPdfAmount: {
    lineHeight: 1.1,
    width: "11.11%",
    fontSize: 8,
    fontFamily: "Roboto",
    marginTop: 5,
    marginBottom: 5,
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "row",
  },
  employeeNameHeading: {
    width: "50%",
    display: "flex",
    flexDirection: "row",
  },
  salesSummaryFlexStart: {
    width: "33.33%",
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row",
  },
  tableHeadOrdersPdf: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: "#F2F5F9",
    borderBottom: 1,
    borderLeft: 1,
    borderRight: 1,
    borderRadius: 12,
    borderTopLeftRadius: 12,
    borderColor: "#f2f0f1",
    marginTop: 4,
    padding: "5px",
    width: "100%",
    alignItems: "center",
  },
  packingSlipFlexStartNO: {
    width: "7%",
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row",
  },
  flexStartCategory: {
    width: "24%",
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row",
    paddingLeft: "6px",
  },
  flexStartItem: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
    paddingLeft: "6px",
  },
  flexStartBrand: {
    width: "18%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    paddingLeft: "6px",
  },
  flexQuantity: {
    width: "10%",
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "row",
    paddingLeft: "6px",
  },
  ordersTableContent: {
    display: "flex",
    flexDirection: "row",
    padding: "4px",
    borderBottom: 1,
    borderColor: "#f2f0f1",
    borderStyle: "solid",
  },
  tableBox: {
    width: "100%",
  },
  packingSlipFlexEndNO: {
    width: "3%",
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row",
  },
  packingSlipFlexStart: {
    width: "10%",
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row",
  },
  packingSlipFlexStartCategory: {
    width: "12%",
    display: "flex",
    justifyContent: "flex-start",
    paddingLeft: "5px",
  },
  packingSlipFlexStartBrand: {
    width: "18% !important",
    display: "flex",
    justifyContent: "flex-start",
    paddingLeft: "5px",
    textOverflow: "ellipsis",
  },
  packingSlipFlexStartItem: {
    width: "34% !important",
    display: "flex",
    justifyContent: "flex-start",
    paddingLeft: "5px",
  },
  packingSlipAmount: {
    width: "10%",
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "row",
    paddingLeft: "5px",
  },
  packingSlipFlexEnd: {
    width: "7%",
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "row",
    paddingLeft: "5px",
  },
  packingSlipFlexQuantity: {
    width: "10%",
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "row",
    paddingLeft: "5px",
  },
  packingSlipFlexEndWeight: {
    width: "10%",
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "row",
    paddingLeft: "5px",
  },
  calculationSectionStyles: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingLeft: 30,
    paddingRight: 17,
    marginBottom: 3,
    marginTop: 10,
  },
  rowend: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 3,
    justifyContent: "space-between",
    padding: "4px",
  },
  salesSummaryFlexEnd: {
    width: "33.33%",
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "row",
  },
  employeeNameHeadingValue: {
    width: "48%",
    display: "flex",
    flexDirection: "row",
  },
  payTypeHeading: {
    width: "26%",
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row",
  },
  payTypeHeadingFood: {
    width: "26%",
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row",
  },
  payNumHeading: {
    width: "26%",
    display: "flex",
    flexDirection: "row",
  },
  payNumHeadingHouseHold: {
    width: "24%",
    display: "flex",
    flexDirection: "row",
  },
  payNumHeadingValue: {
    width: "26.5%",
    justifyContent: "flex-start",
    display: "flex",
    flexDirection: "row",
  },
  payNumHeadingValueFoodNext: {
    display: "flex",
    flexDirection: "row",
  },
  payNumHeadingAmountValue: {
    width: "28.5%",
    display: "flex",
    flexDirection: "row",
  },
  payNumHeadingAmountFood: {
    width: "24%",
    display: "flex",
    flexDirection: "row",
  },
  payNumHeadingTips: {
    width: "16.2%",
    display: "flex",
    flexDirection: "row",
  },
  payNumHeadingFoods: {
    width: "14.2%",
    display: "flex",
    flexDirection: "row",
  },
  payReceiptHeading: {
    width: "18.5%",
    display: "flex",
    flexDirection: "row",
  },
  payReceiptTotal: {
    width: "20%",
    display: "flex",
    flexDirection: "row",
  },
  twoColumnTotal: {
    width: "60%",
  },
  numHeading: {
    width: "35%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  payTypeHeadingValuePdf: {
    width: "20%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  payTypeHeadingValuePdfName: {
    width: "20%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  itemSummaryFlexStart: {
    width: "25%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  itemSummaryFlexEnd: {
    width: "25%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  numHeadingGrandTotal: {
    width: "30%",
    display: "flex",
  },
  numHeadingCheckPdf: {
    width: "35.5%",
    display: "flex",
  },
  flexRow: {
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "row",
    width: "20%",
    marginTop: 5,
  },
  totalReceiptHeading: {
    width: "15%",
    display: "flex",
    marginLeft: 8,
  },
  totalReceiptHeadingGrandTotal: {
    display: "flex",
  },
  totalReceiptProfileHeading: {
    width: "15%",
    display: "flex",
    marginLeft: 8,
  },
  tableColPdfItemHead: {
    lineHeight: 1.1,
    width: "11.11%",
    display: "flex",
    justifyContent: "flex-start",
    marginLeft: "auto",
    marginRight: "auto",
    fontSize: 8,
    fontFamily: "Roboto",
    marginTop: 5,
    flexDirection: "row",
    marginBottom: 5,
  },
  tableColPdfAmountHead: {
    lineHeight: 1.1,
    width: "11.11%",
    flexDirection: "row",
    display: "flex",
    justifyContent: "flex-end",
    marginLeft: "auto",
    marginRight: "auto",
    fontSize: 8,
    fontFamily: "Roboto",
    marginTop: 5,
    marginBottom: 5,
  },

  tableColPdfItemRow: {
    lineHeight: 1.1,
    width: "11.11%",
    marginLeft: "auto",
    paddingLeft: 2,
    fontSize: 8,
    fontFamily: "Roboto",
    marginTop: 5,
    marginBottom: 5,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  tableColPdfCategoryHead: {
    lineHeight: 1.1,
    width: "11.11 %",
    display: "flex",
    justifyContent: "flex-start",
    marginLeft: "auto",
    marginRight: "auto",
    fontSize: 8,
    fontFamily: "Roboto",
    marginTop: 5,
    marginBottom: 5,
  },
  tableColPdfItem: {
    lineHeight: 1.1,
    width: "11.11%",
    display: "flex",
    justifyContent: "flex-start",
    marginLeft: "auto",
    marginRight: "auto",
    fontSize: 8,
    fontFamily: "Roboto",
    marginTop: 5,
    marginBottom: 5,
  },
  itemColPdf: {
    lineHeight: 1.1,
    width: "18%",
    display: "flex",
    justifyContent: "flex-start",
    fontSize: 8,
    fontFamily: "Roboto",
    marginLeft: "5px",
  },
  tableColPdfBrandHead: {
    lineHeight: 1.1,
    width: "11.11%",
    display: "flex",
    justifyContent: "flex-start",
    marginLeft: "auto",
    marginRight: "auto",
    fontSize: 8,
    fontFamily: "Roboto",
    marginTop: 5,
    marginBottom: 5,
  },
  tableColPdfBrandHeadPdf: {
    lineHeight: 1.1,
    width: "11.11%",
    display: "flex",
    justifyContent: "flex-start",
    marginLeft: "auto",
    marginRight: "auto",
    fontSize: 8,
    fontFamily: "Roboto",
    marginTop: 5,
    marginBottom: 5,
  },
  texttcomPdf: {
    fontSize: 8,
    fontFamily: "Roboto",
    color: "black",
    marginTop: 1,
    marginBottom: 1,
  },
  textDonePdf: {
    fontSize: 7,
    fontFamily: "Roboto",
    marginTop: 1,
    marginBottom: 1,
    lineHeight: 1.1,
    color: "black",
  },
  brandtablecol: {
    width: "20%",
    display: "flex",
    justifyContent: "flex-start",
    marginLeft: 2,
  },
  itemtablecol: {
    width: "40%",
    fontSize: 10,
    display: "flex",
    justifyContent: "flex-start",
    marginRight: 10,
  },
  textth2: {
    fontSize: 12,
    fontWeight: 1100,
    color: "#121722",
  },
  textNum: {
    marginTop: 4,
    marginBottom: 4,
    fontSize: 10,
    marginLeft: 10,
  },
  tablePadding: {
    display: "flex",
    flexDirection: "row",
    padding: 4,
  },
  headerTableSummary: {
    width: "530px",
  },
  tablePaddingDebit: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 6,
    paddingRight: 6,
    marginLeft: 12,
    marginRight: 12,
  },
  tablePaddingCredit: {
    display: "flex",
    flexDirection: "row",
    padding: 4,
    marginLeft: 10,
    justifyContent: "space-between",
  },
  tableRowColumn: {
    display: "flex",
    flexDirection: "column",
    padding: 4,
    marginLeft: 10,
  },
  tablerow: {
    display: "flex",
    flexDirection: "row",
    paddingTop: 4,
    marginTop: 5,
    marginLeft: 14,
  },
  tablerowPackingSlip: {
    display: "flex",
    flexDirection: "row",
    paddingTop: 4,
    marginTop: 5,
    marginLeft: 46,
  },
  numbertextt: {
    marginLeft: "auto",
    marginRight: "auto",
    fontSize: 10,
    lineHeight: 1,
  },
  numTextt: {
    fontSize: 10,
    lineHeight: 1,
  },
  creditCardsCss: {
    marginRight: 12,
    fontSize: 10,
  },
  topValues: {
    marginLeft: "auto",
    marginRight: "auto",
    fontSize: 10,
  },
  textt: {
    lineHeight: 1,
    marginLeft: 2,
    fontSize: 10,
  },
  texttPdf: {
    fontFamily: "Roboto",
    fontSize: 10,
    fontWeight: 100,
  },
  texttPdfBrand: {
    fontFamily: "Roboto",
    fontSize: 10,
    fontWeight: 100,
  },
  texttPdfPrice: {
    fontSize: 10,
    fontFamily: "Roboto",
    marginTop: 1,
    marginBottom: 1,
  },
  texttPdfCategory: {
    fontSize: 10,
    fontFamily: "Roboto",
    marginTop: 1,
    marginBottom: 1,
    width: "11.11%",
  },
  texttPdfItem: {
    fontFamily: "Roboto",
    fontSize: 10,
    fontWeight: 100,
  },
  bolder: {
    lineHeight: 1,
    marginLeft: 2,
    fontSize: 12,
  },
  borderBtm30px: {
    marginBottom: 30,
    flexDirection: "row",
  },
  spacer: {
    marginBottom: 6,
    flexDirection: "row",
  },
  businessDetailsRow: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingLeft: 10,
    marginTop: 10,
  },
  currencyrowTotalQuantity: {
    fontSize: 10,
    fontWeight: "bold",
  },
  currencyrowTotalQuantityPdf: {
    fontSize: 10,
    fontWeight: "bold",
    display: "flex",
    justifyContent: "flex-end",
  },
  currencyrow2: {
    width: "30%",
  },
  flexRowCenter: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  currencyRow: {
    width: "40%",
  },
  currencyRow2Pdf: {
    width: "40%",
  },
  grandTotal: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  texth2th: {
    fontSize: 10,
  },
  thankyouMessage: {
    fontSize: 14,
    fontWeight: 600,
  },
  grandTotalLabel: {
    fontSize: 14,
    fontWeight: 400,
    color: "#60737D",
  },
  currencyColor: {
    fontSize: 12,
    color: "#121722",
  },
  grandTotalValue: {
    fontSize: 16,
    fontWeight: 700,
    marginLeft: 109,
    marginRight: 10,
  },
  currencyRowEmail: {
    display: "flex",
    flexDirection: "row",
    height: 30,
    alignItems: "center",
    width: "50%",
  },
  currencyRowPhone: {
    display: "flex",
    flexDirection: "row",
    marginRight: 10,
    width: "48%",
    height: 30,
    paddingLeft: 5,
    borderRadius: 12,
    backgroundColor: "#F2F5F9",
    alignItems: "center",
  },
  texth2tDeliveryCharges: {
    marginLeft: 96,
    fontSize: 10,
  },
  textTax: {
    marginLeft: 158,
    fontSize: 10,
  },
  texServiceCharges: {
    marginLeft: 99,
    fontSize: 10,
  },
  texth2tDiscount: {
    marginLeft: 133,
    fontSize: 10,
  },
  texth2tCouponCode: {
    fontSize: 10,
    display: "flex",
  },
  texth2t: {
    marginLeft: 151,
    fontSize: 10,
  },
  texth2tTotal: {
    fontSize: 10,
    display: "flex",
    alignItems: "center",
  },
  texttcom: {
    marginLeft: "2px",
    fontSize: 8,
    color: "black",
    lineHeight: 0.8,
  },
  texth2g: {
    lineHeight: 1.1,
    fontSize: 14,
    fontWeight: "bold",
    marginTop: 4,
    marginBottom: 6,
  },
  texth2g2: {
    lineHeight: 1.1,
    fontSize: 14,
    fontWeight: "bold",
    marginTop: 4,
    marginBottom: 6,
  },
  texttaddone: {
    lineHeight: 1,
    fontSize: 7,
    color: "black",
  },
  boldOptionSet: {
    lineHeight: 1,
    fontSize: 10,
  },
  footer: {
    width: "90%",
    flexDirection: "row",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 1,
  },
  hst: {
    justifyContent: "flex-start",
    marginRight: "auto",
    fontSize: 9,
    color: "#121111",
  },
  phone: {
    justifyContent: "flex-start",
    marginLeft: "auto",
    fontSize: 9,
    color: "#121111",
  },
  email: {
    justifyContent: "flex-start",
    marginLeft: "auto",
    marginRight: "auto",
    fontSize: 9,
    color: "#121111",
  },
});
